import { epicRequest } from 'app'

export const PLAYING_NOW_FETCH = 'PLAYING_NOW_FETCH'
export const PLAYING_NOW_FETCH_ERROR = 'PLAYING_NOW_FETCH_ERROR'
export const PLAYING_NOW_FETCH_FULFILLED = 'PLAYING_NOW_FETCH_FULFILLED'
export const PLAYING_NOW_FETCH_CANCELED = 'PLAYING_NOW_FETCH_CANCELED'

export const PLAYING_NOW_INITIAL_STATE = {
  data: [],
  error: null,
  pagination: null,
}

export const playingNowFetch = () => ({
  payload: {},
  type: PLAYING_NOW_FETCH,
})

export const playingNowFetchFulfilled = (payload) => ({
  payload,
  type: PLAYING_NOW_FETCH_FULFILLED,
})

export const playingNowFetchCanceled = () => ({
  payload: null,
  type: PLAYING_NOW_FETCH_CANCELED,
})

export const playingNowFetchError = (payload) => ({
  payload,
  type: PLAYING_NOW_FETCH_ERROR,
})
export const playingNowFetchEpic = epicRequest({
  actionType: PLAYING_NOW_FETCH,
  errorAction: playingNowFetchError,
  fulfilledAction: playingNowFetchFulfilled,
  request: 'sports/soccer/matches/playing',
  untilTypes: PLAYING_NOW_FETCH_CANCELED,
})
